import type { ReactNode } from "react";
import { useInputSearchContext } from "./InputSearchContext";

const DEFAULT_EMPTY_FALLBACK = <div className="p-3">No results</div>;

export function InputSearchDropdown({
  children,
  isLoading = false,
  hasResults = true,
  loadingFallback = null,
  emptyFallback = DEFAULT_EMPTY_FALLBACK,
}: {
  children: ReactNode | ((options: { close: () => void }) => ReactNode);
  isLoading?: boolean;
  hasResults?: boolean;
  loadingFallback?: ReactNode;
  emptyFallback?: ReactNode;
}) {
  const { value, setDropdownActive } = useInputSearchContext();

  if (isLoading) return loadingFallback;
  if (value && !hasResults) return emptyFallback;

  const close = () => setDropdownActive(false);

  return typeof children === "function" ? children({ close }) : children;
}
